export default __webpack_public_path__ + "static/media/iconGithub.04be58c1.svg";